import { useCallback } from 'react';

import { usePopups } from '../services';
import { BLOG_SECTION_INSTRUCTIONS_FROM_URL } from '../types';

export const useImportBlogSectionInstructionsFromURLPopup = ({
  onSubmitCallback,
  onOpenCallback,
  sectionId,
  headline,
}) => {
  const popups = usePopups();

  return useCallback(() => {
    onOpenCallback();

    popups.openPopup(BLOG_SECTION_INSTRUCTIONS_FROM_URL, {
      onClose: () => {
        popups.closePopup(BLOG_SECTION_INSTRUCTIONS_FROM_URL);
      },
      onSubmit: onSubmitCallback,
      sectionId,
      headline,
    });
  }, [onOpenCallback, popups, onSubmitCallback, sectionId, headline]);
};
